import { Model } from '@/clients/http'

/** Sample records copied from the category's demo store when the business was created. */
export interface SampleDataStatus {
  has_sample: boolean
  counts: Record<string, number>
}

export interface SampleDataApiError {
  message?: string
}

export class SampleDataModel extends Model {
  public static readonly correlations = {
    GET: 'GET_SAMPLE_DATA',
    DELETE: 'DELETE_SAMPLE_DATA',
  }

  public static readonly endpoints = {
    base: () => this.createEndpoint({ url: '/api/backoffice/sample-data' }),
  }

  public static readonly get = async () =>
    this.createHttpRequest<SampleDataStatus, SampleDataApiError>({
      correlationKey: this.correlations.GET,
      payload: { method: 'get', url: this.endpoints.base(), useBearerToken: true },
    })

  public static readonly remove = async () =>
    this.createHttpRequest<Partial<SampleDataStatus>, SampleDataApiError>({
      correlationKey: this.correlations.DELETE,
      payload: { method: 'delete', url: this.endpoints.base(), useBearerToken: true },
    })
}
